import id from './id.js'
import initialState from './initial-state.js'
import selectorDefinitions from './selectors/index.js'

const syncedBalancesReduxDefinition = {
  id,
  type: 'redux-module',
  initialState,
  eventReducers: {
    syncedBalances: (state, payload) => ({
      ...state,
      data: payload,
      loaded: true,
    }),
  },
  selectorDefinitions,
}

export default syncedBalancesReduxDefinition
